import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCrossMedium"><Path d="M18.9141 6.5L13.4141 12L18.9141 17.5L17.5 18.9141L12 13.4141L6.5 18.9141L5.08594 17.5L10.5859 12L5.08594 6.5L6.5 5.08594L12 10.5859L17.5 5.08594L18.9141 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrossMedium;
